<template>
<div class="chapter">
<div class="inner_page">
<p class="ep-sp"> </p>
<p class="epv-top" id="epi"><span class="epub-i">Every ending is arbitrary, because the end is where you write</span> The end<span class="epub-i">. A period, a dot of punctuation, a point of stasis.</span> <span class="epub-i">A pinprick in the paper: you could put your eye to it and see</span> <span class="epub-i">through, to the other side, to the beginning of something else.</span></p>
<p class="epc">—Margaret Atwood, <span class="epub-i">The Robber Bride</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// epigraph.vue?a0a63c12